import React from "react";
import Event from "@ckeditor/ckeditor5-utils/src/eventinfo";
import { EditorConfig } from "@ckeditor/ckeditor5-core/src/editor/editorconfig";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5/build/ckeditor";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useIntl } from "react-intl";
import { useStartup } from "src/app/utils/useStartup";

export interface ScribensEditorConfig extends EditorConfig {
    scribens?: { limit?: number; lang?: "EN" | "FR" };
}
export interface ICKEditorProps {
    disabled?: boolean;
    data?: string;
    id?: string;
    config?: ScribensEditorConfig;
    onReady?: (editor: ClassicEditor) => void;
    onChange?: (event: Event, editor: ClassicEditor) => void;
    onBlur?: (event: Event, editor: ClassicEditor) => void;
    onFocus?: (event: Event, editor: ClassicEditor) => void;
    onError?: (event: Event, editor: ClassicEditor) => void;
}
const CkEditorCustom: React.FC<ICKEditorProps> = (CKEditorProps) => {
    const { formatMessage } = useIntl();
    const { startupMessage } = useStartup();
    return (
        <CKEditor
            editor={Editor}
            config={{
                heading: {
                    options: [
                        {
                            model: "paragraph",
                            title: `${formatMessage({ id: "editor.paragraph" })}`,
                            class: "ck-heading_paragraph",
                        },
                        {
                            model: "heading1",
                            view: "h2",
                            title: `${formatMessage({ id: "editor.heading2" })}`,
                            class: "ck-heading_heading1",
                        },
                        {
                            model: "heading2",
                            view: "h3",
                            title: `${formatMessage({ id: "editor.heading3" })}`,
                            class: "ck-heading_heading2",
                        },
                        {
                            model: "heading3",
                            view: "h4",
                            title: `${formatMessage({ id: "editor.heading4" })}`,
                            class: "ck-heading_heading3",
                        },
                    ],
                },

                toolbar: {
                    items: [
                        "heading",
                        "|",
                        "bold",
                        "italic",
                        "underline",
                        "link",
                        "bulletedList",
                        "numberedList",
                        "|",
                        "outdent",
                        "indent",
                        "|",
                        "blockQuote",
                        "scribensPlugin",
                        "|",
                        "undo",
                        "redo",
                    ],
                },
                language: "fr",
                scribens: {
                    limit: process.env.REACT_APP_SCRIBENS_LIMIT,
                    api_key: startupMessage?.scribensApiKey,
                    lang: "fr",
                },
                removePlugins: ["MediaEmbedToolbar"],
                ...CKEditorProps.config,
            }}
            {...CKEditorProps}
        />
    );
};

export default CkEditorCustom;
